import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { JpmamDestinationCreateDrawer } from '../../../../../../../../../../features/vendor/jpmam/destination/jpmam-destination-create-drawer';
import { JpmamDestinationsTable } from '../../../../../../../../../../features/vendor/jpmam/destination/jpmam-destinations-table';
import { JpmamVendorTabRail } from '../../../../../../../../../../features/vendor/jpmam/jpmam-vendor-tab-rail';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorJpmam,
      label: 'Destinations',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorJpmam>,
  head: () => getPageHead('JPMAM Destinations'),
  component: JpmamDestinationList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <VerticalStack gap={7}>
      <JpmamVendorTabRail
        actions={
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            <RequiresAccess write>
              <JpmamDestinationCreateDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Destination" size="small" />} />
            </RequiresAccess>
            {filter}
          </HorizontalStack>
        }
      />
    </VerticalStack>
  );
}

function JpmamDestinationList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <JpmamDestinationsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
